import Service from "../../services";
import logger from "vuex/dist/logger";

const state = {
  collection_id: 0,
  collections: [],
  collections_lenght: null,
  collections_by_id: [],
  category_collections: [],
  category_collection_data: [],
  paginate: {
    current_page: 1,
    next_page: "",
  },
};

const getters = {};

const actions = {
  getCollectionoHighlight({ commit }) {
    return Service.collection.getCollectionoHighlight().then((res) => {
      return res;
    });
  },
  getCollectionById({ commit }, val) {
    return Service.collection
      .getCollectionById(val)
      .then((res) => {
        let data = {
          collection_id: val.id,
          paginate: res.data.paginate,
          collections: res.data.collections,
          category_collection_data: res.data.category_collections,
        };
        commit("SET_COLLECTION", data);
        return res.data;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  clearActiveMenuCreator({ commit }, val) {
    commit("CLEAR_ACTIVE_MENU_CREATOR");
    // return Service.collection
    //   .getCollectionById(val)
    //   .then((res) => {
    //     let data = {
    //       collection_id: val.id,
    //       paginate: res.data.paginate,
    //       collections: res.data.collections,
    //       category_collection_data: res.data.category_collections,
    //     };
    //     commit("SET_COLLECTION", data);
    //     commit("CLEAR_ACTIVE_MENU_CREATOR");
    //     return res.data;
    //   })
    //   .catch((err) => {
    //     return Promise.reject(err);
    //   });
  },
  getCollectionMore({ commit, state }, val) {
    return (
      Service.collection
        // .getMoreCollection(val)
        .getCollectionById(val)
        .then((res) => {
          let resCollection = res.data.collections;
          // merge ข้อมมูลเก่ากับข้อมูลใหม่
          resCollection = [
            ...state.collections,
            ...Object.values(resCollection),
          ];

          let data = {
            collection_id: val.id,
            paginate: res.data.paginate,
            collections: resCollection,
            category_collection_data: res.data.category_collections,
          };
          commit("SET_COLLECTION_MORE", data);
          return res.data;
        })
        .catch((err) => {
          return Promise.reject(err);
        })
    );
  },
  getCategoryCollection({ commit }) {
    return Service.collection
      .getCategoryCollection()
      .then((res) => {
        // commit('SET_CATEGORY_COLLECTION', res.data);
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  getCollectionPortfolio({ commit }, data) {
    return Service.collection
      .getCollectionPortfolio(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  getMoreCollectionPortfolio({ commit }, data) {
    return Service.collection.getMoreCollectionPortfolio(data).then((res) => {
      return res;
    });
  },
  onGetCollectionById({ commit }, id) {
    return Service.collection.onGetCollectionById(id).then((res) => {
      commit("SET_COLLECTION_BY_ID", res);
      return res;
    });
  },
  getCreatorPortfolio({ commit }) {
    return Service.collection.getCreatorPortfolio().then((res) => {
      return res;
    });
  },
};

const mutations = {
  SET_COLLECTION(state, val) {
    state.collection_id = val.collection_id;
    state.collections = val.collections;
    // state.collections_lenght = val.collections.data.length;
    state.paginate.current_page = val.paginate.current_page;
    state.paginate.next_page = val.paginate.next_page;
    state.category_collection_data = val.category_collection_data;
  },
  SET_COLLECTION_MORE(state, val) {
    state.collection_id = val.collection_id;
    state.collections = val.collections;
    state.paginate.current_page = val.paginate.current_page;
    state.paginate.next_page = val.paginate.next_page;
    state.category_collection_data = val.category_collection_data;
  },
  SET_CATEGORY_COLLECTION(state, val) {
    state.category_collections = val;
  },
  SET_COLLECTION_BY_ID(state, val) {
    state.collections_by_id = val;
  },

  CLEAR_COLLECTION(state) {
    state.collection_id = 0;
    state.collections = [];
    state.collections_lenght = null;
    state.collections_by_id = [];
    state.category_collections = [];
    state.category_collection_data = [];
    state.paginate = {
      current_page: 1,
      next_page: "",
    };
  },
  CLEAR_ACTIVE_MENU_CREATOR(state) {
    state.collection_id = 15;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
